import { AtlassianSwitcherPrefetchTrigger, SwitchToTooltipText } from '@atlaskit/atlassian-switcher';
import AppSwitcherIcon from '@atlaskit/icon/glyph/app-switcher';
import { colors } from '@atlaskit/theme';
import Tooltip from '@atlaskit/tooltip';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { defineMessages, InjectedIntlProps, injectIntl } from 'react-intl';

import Store from '../../store';
import { Drawer } from '../../store/drawerStore';
import DrawerStore from '../../store/drawerStore';
import UIStore from '../../store/uiStore';
import FastTap from '../mobile/FastTap';

interface Props {
  drawerStore: DrawerStore;
  uiStore: UIStore;
}

@observer
class SwitcherDrawerButton extends React.Component<Props & InjectedIntlProps> {
  render() {
    const { intl } = this.props;

    return (
      <AtlassianSwitcherPrefetchTrigger>
        <Tooltip content={SwitchToTooltipText} position={this.getTooltipPosition()}>
          <FastTap onClick={this.handleClick}>
            <AppSwitcherIcon label={intl.formatMessage(messages.switcher)} primaryColor={colors.N700} />
          </FastTap>
        </Tooltip>
      </AtlassianSwitcherPrefetchTrigger>
    );
  }

  private getTooltipPosition = () => (this.props.uiStore.mobileMode ? 'bottom' : 'right');

  private handleClick = () => {
    this.props.drawerStore.openDrawer(Drawer.Switcher);
  };
}

export default inject(({ drawerStore, uiStore }: Store) => ({
  drawerStore,
  uiStore,
}))(injectIntl(SwitcherDrawerButton));

const messages = defineMessages({
  switcher: {
    defaultMessage: 'Switch to...',
    description: `Button to show the user products they have access and can switch into`,
    id: 'uchi.switcherbutton.label',
  },
});
